import { render } from "./MenuBtn.vue?vue&type=template&id=ce509ffc"
import script from "./MenuBtn.vue?vue&type=script&lang=js"
export * from "./MenuBtn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__